import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useHasPermission } from '@/lib/hooks/usePermission'
import type { PracticeCase } from '@/api/practice-cases'
import { AlertTriangle } from 'lucide-react'

interface DeletePracticeCaseDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  practiceCase: PracticeCase
  onConfirm: () => void
  isDeleting: boolean
}

export function DeletePracticeCaseDialog({
  open,
  onOpenChange,
  practiceCase,
  onConfirm,
  isDeleting,
}: DeletePracticeCaseDialogProps) {
  const canDeletePractice = useHasPermission('practice.delete')
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center h-10 w-10 rounded-full bg-red-100 dark:bg-red-950">
              <AlertTriangle className="h-5 w-5 text-red-600 dark:text-red-400" />
            </div>
            <DialogTitle>Oefenscenario verwijderen</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            Weet je zeker dat je het oefenscenario <strong>"{practiceCase.title}"</strong> wilt
            verwijderen?
            <br />
            <br />
            Dit oefenscenario wordt verwijderd uit de lijst en kan niet meer worden gebruikt voor
            nieuwe crises. Bestaande crises die dit scenario gebruiken blijven werken. De
            auditgeschiedenis blijft behouden.
          </DialogDescription>
        </DialogHeader>

        {!canDeletePractice && (
          <div className="mb-4 p-3 text-sm text-orange-600 bg-orange-50 border border-orange-200 rounded-md dark:bg-orange-950/20 dark:text-orange-400 dark:border-orange-800">
            U heeft geen toestemming om oefenscenario's te verwijderen.
          </div>
        )}

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Annuleren
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting || !canDeletePractice}
          >
            {isDeleting ? 'Verwijderen...' : 'Verwijderen'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
